import React from 'react';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Styles
import './styles.scss';

// Components
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AnalyticsService } from 'src/Analytics/AnalyticsService';

const NavigateBack = (props) => {
  const { t } = useTranslation();
  const {
    text = t('back'),
    isDisabled = false,
    onClick = () => {
      window.digitalData.link = {
        linkName: 'Back',
        linkType: 'Navigation Link',
      };

      AnalyticsService.trackEvent('link_click');
      props.history.goBack();
    },
  } = props;
  return isDisabled ? (
    <div className="navigate-back-container is-disabled">
      <span className="icon-text-container_navigate hover-hand">
        <FontAwesomeIcon icon={faChevronLeft} color={'#63666A'} />
        <span className="text-container">{text}</span>
      </span>
    </div>
  ) : (
    <div className="navigate-back-container" onClick={onClick}>
      <span className="icon-text-container_navigate hover-hand">
        <FontAwesomeIcon icon={faChevronLeft} color={'#51BDDF'} />
        <span className="text-container">{text}</span>
      </span>
    </div>
  );
};

export default withRouter(NavigateBack);
